// Adds listbox navigation to the existing dashboard search contracts. Selection
// still calls each role's original navigation/filter handler.
export default {
  data() { return { keyboardSearchIndex: -1, keyboardSearchId: 'dashboard-search-' + this._uid }; },
  watch: {
    searchQuery() { this.keyboardSearchIndex = -1; },
    searchMatches() { this.keyboardSearchIndex = -1; },
  },
  methods: {
    closeKeyboardSearch() { this.keyboardSearchIndex = -1; this.closeSearchDropdown(); },
    onKeyboardSearch(event) {
      if (event.isComposing || event.altKey || event.ctrlKey || event.metaKey) return;
      if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault();
        this.showSearchDropdown = true;
        const count = this.searchMatches.length;
        this.keyboardSearchIndex = count ? (this.keyboardSearchIndex < 0
          ? (event.key === 'ArrowDown' ? 0 : count - 1)
          : (this.keyboardSearchIndex + (event.key === 'ArrowDown' ? 1 : -1) + count) % count) : -1;
        this.$nextTick(() => {
          const option = document.getElementById(this.keyboardSearchId + '-' + this.keyboardSearchIndex);
          if (option && option.scrollIntoView) option.scrollIntoView({ block: 'nearest' });
        });
      } else if (event.key === 'Enter') {
        if (event.shiftKey) return; // Preserve the original .enter.exact contract.
        event.preventDefault();
        if (event.repeat) return;
        const match = this.showSearchDropdown && this.searchMatches[this.keyboardSearchIndex];
        if (match) this.onSelectSearchResult(match);
        else this.onSearchEnter();
      } else if (event.key === 'Escape') {
        if (this.showSearchDropdown) { event.preventDefault(); event.stopPropagation(); }
        this.closeKeyboardSearch();
      }
    },
  },
};
